module.exports = __webpack_public_path__ + "static/europe-map-15fa720ce30f3923bea5c321f5d7b93b.svg";